"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _SVBTypography = require("../../SVBTypography");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * SVB Footer
 * <SVBFooter footerContent={footerJSON} />
 */

/**
 * SVBFooter
 * @param footerContent: json array of footer-link objs
 * see ../readme.MD for sample body
 * @param fixed: to set fixed-bottom
 * @param extraClasses: additional styling classes
 * @returns footer HTML with content
 */

const SVBFooter = props => {
  const {
    footerContent,
    fixed,
    extraClasses,
    copyRightText,
    isExternal = false,
    dataTestid
  } = props;
  // If fixed prop exists, we set it.
  // Otherwise, static by default.
  const typeClass = fixed ? "fixed-bottom" : "";
  const extClasses = extraClasses ? extraClasses : "";
  // svb-footer needs to be applied by default, any other additional classes
  // are added before render
  const Classes = typeClass + " svb-footer " + extClasses;
  const copyRightTextContent = copyRightText ? copyRightText : "\xA9 ".concat(new Date().getFullYear(), " First-Citizens Bank & Trust Company. Silicon Valley Bank, a division of First-Citizens Bank & Trust Company. Member FDIC.");
  const ExternalElement = () => /*#__PURE__*/_react.default.createElement("footer", {
    className: Classes
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list svb-footer-links d-flex"
  }, footerContent && footerContent.map((footerItem, i) =>
  /*#__PURE__*/
  // Applying key to outer react.fragment
  _react.default.createElement(_react.default.Fragment, {
    key: i
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "footer-link-item"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: footerItem.link,
    title: footerItem.description ? footerItem.description : "",
    className: "footer-link"
  }, footerItem.name)), i < footerContent.length - 1 && "|"))), /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
    type: "paragraph",
    variant: "x-small footer-text"
  }, copyRightTextContent));
  const InternalElement = () => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", {
    className: "m-0 hr-background"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "container pt-3 ".concat(extClasses),
    "data-testid": dataTestid ? dataTestid : null
  }, /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
    variant: "sub-heading-medium"
  }, copyRightTextContent)));
  return isExternal ? /*#__PURE__*/_react.default.createElement(ExternalElement, null) : /*#__PURE__*/_react.default.createElement(InternalElement, null);
};
var _default = SVBFooter;
exports.default = _default;